import "core-js/modules/es.array.push.js";
import store from "store2";
import { mapMutations, mapState } from "vuex";
import { setUnitNumber } from "@/libs/auth";
import { acceptInvite } from "@/service/structure";
import { getQueryString } from "@/utils/util";
import { entryUnit, getUserUnit } from "@/service/user";
export default {
  name: "m_Join",
  data() {
    return {
      success: false
    };
  },
  computed: {
    ...mapState({
      language: state => state.app.language
    }),
    name() {
      return getQueryString("name");
    }
  },
  methods: {
    ...mapMutations(["setLanguage", "getUserInfo"]),
    async ok() {
      const params = {
        userId: getQueryString("userId") || store.get("userInfo").userId,
        inviteCode: getQueryString("inviteCode")
      };
      let res = await acceptInvite(params);
      if (res.data && res.data.result === 0) {
        this.success = true;
        let {
          data: {
            result
          }
        } = await entryUnit(res.data.retVal);
        // localStorage.setItem("unit", item);
        if (result === 25003) {
          this.$router.push("/login");
        } else if (result === 0) {
          let res2 = await getUserUnit();
          if (res2.data && res2.data.result === 0) {
            let units = res2.data.retVal;
            setUnitNumber(units);
          }
          this.$Message.success($t("wcx3trd", "受邀成功，正在前往应用首页"));
          setTimeout(() => {
            this.$router.push({
              name: this.$config.homeName
            });
          }, 1000);
        }
      }
    },
    goTo() {
      // this.$router.push("/login");
    },
    setLanguageF() {
      const language = getQueryString("language");
      this.setLanguage(language);
    }
  }
};